export const getCommandElementLabel = (elem) =>
  ['image'].includes(elem.type)
    ? elem?.slackEl?.title?.text || elem.type
    : ['mrkdwn'].includes(elem.type)
      ? 'Markdown'
      : elem?.slackEl?.label?.text || elem.type
// a little function to help us with reordering the result
export const Reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const grid = 6
export const getItemStyle = (isDragging, draggableStyle, isHide = false) => {
  return {
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    display: 'grid',
    gridTemplateAreas: '"label" "content"',
    gridTemplateColumns: '1fr',
    // padding: grid * 2,
    // margin: `0 0 ${grid}px 0`,
    textAlign: 'left',
    height: 'auto',
    opacity: isHide ? 0.6 : 1,

    // change background colour if dragging
    // background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle,
  }
}
export const getEmailItemStyle = (isDragging, draggableStyle, isHide = false) => {
  return {
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    display: 'grid',
    gridTemplateAreas: '"label" "content"',
    gridTemplateColumns: '1fr',
    // padding: grid * 2,
    // margin: `0 0 ${grid}px 0`,
    textAlign: 'left',
    height: 'auto',
    opacity: isHide ? 0.6 : 1,

    // change background colour if dragging
    // background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle,
  }
}

export const getElementItemStyle = (isDragging, draggableStyle) => {
  return {
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    display: 'grid',
    gridTemplateAreas: '"label icon" "content content"',
    gridTemplateColumns: '26px 1fr auto',
    // padding: grid * 2,
    // margin: `0 0 ${grid}px 0`,
    textAlign: 'left',
    alignItems: 'center',

    // change background colour if dragging
    // background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle,
  }
}

export const getQuestionListStyle = (isDraggingOver) => ({
  // background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: '0',
  width: '100%',
})

export const getAnswerListStyle = (isDraggingOver) => ({
  // background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: 0,
  // width: 250
})
